import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, grey } from '../colors';

export const defaultColor = (mode: PaletteMode): ChronosphereColorPalette => {
  return mode === 'light'
    ? {
        main: grey[400],
        highContrast: grey[700],
        lowContrast: grey[150],
      }
    : {
        main: grey[400],
        highContrast: grey[150],
        lowContrast: grey[800],
      };
};
